<template>
  <div>
    <!-- header -->
    <v-container
        fluid
        class="py-0 pb-0 mb-0"
        style="box-shadow: 0px 2px 10px rgba(9, 14, 24, 0.1); background-color: white; z-index: 998; position:fixed;">
      <v-container>
        <v-row>
          <v-col class="py-0">
            <v-container class="py-0">
              <v-row>
                <v-col cols="2" class="py-0">
                  <div
                      class="d-flex align-center justify-start"
                      style="height: 100%"
                  >
                    <router-link :to="`${$route.params.lang === 'en' ? '/en' : '/'}`">
                      <img src="@/assets/edu-logo.svg"/>
                    </router-link>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" class="py-0">
                  <div class="d-flex align-center justify-end" style="height: 100%">
                    <v-menu
                        offset-y
                        bottom
                        origin="center center"
                        transition="scale-transition"
                        content-class="my-menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="accent text-none elevation-0 white--text px-6"
                            style="font-weight: 600"
                            height="40"
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon left class="mt-1">mdi-clipboard-account</v-icon>
                          {{ punoIme }}
                        </v-btn>
                      </template>
                      <v-list class="pa-0" style="background-color: rgba(68, 138, 255, 1)">
                        <v-list-item
                            @click="performLogout">
                          <v-icon color="white" small left>mdi-logout-variant</v-icon>
                          <v-list-item-title class="white--text text-none">{{ $t('logout') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

              <!--        <v-row class="hidden-md-and-up">-->
              <!--          <v-col class="py-4 d-flex align-center justify-start">-->
              <!--            <router-link to="/">-->
              <!--              <img src="@/assets/edu-logo.svg" />-->
              <!--            </router-link>-->
              <!--          </v-col>-->
              <!--          <v-col v-if="!menu" class="py-0 d-flex justify-end">-->
              <!--            <v-icon @click="menu = true" color="secondary" size="28"-->
              <!--            >mdi-menu</v-icon-->
              <!--            >-->
              <!--          </v-col>-->
              <!--          <v-col-->
              <!--              v-else-->
              <!--              @click="menu = false"-->
              <!--              class="py-0 d-flex justify-end"-->
              <!--          >-->
              <!--            <v-icon color="secondary" size="28">mdi-close</v-icon>-->
              <!--          </v-col>-->
              <!--        </v-row>-->
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid py-0 style="background-color: #E4E7EA;">
      <v-container style="padding-top: 120px">
        <v-row>
          <v-col cols="12">
            <div class="text-h4 accent--text">
              {{ $t('page_title') }}
            </div>
          </v-col>

          <v-col cols="12">
            <v-breadcrumbs
                class="pl-0 ml-0"
                :items="breadcrumbs"
                large
                divider="/"
            ></v-breadcrumbs>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" style="height: 100%">
            <v-row>
              <v-col cols="12">
                <v-card outlined>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <!--                      <v-avatar size="150" style="border: 2px solid #448AFF">-->
                      <img v-if="loggedUser.avatar_url == null"
                           src="@/assets/profile.png"
                           alt="John"
                           style="max-height: 180px; border: 2px solid #448AFF; border-radius: 15px"
                      >
                      <img v-else
                           :src="loggedUser.avatar_url "
                           alt="John"
                           style="max-height: 180px; border: 2px solid #448AFF; border-radius: 15px"
                      >
                      <!--                      </v-avatar>-->

                    </v-col>
                    <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                      <div style="height: 1px; background: linear-gradient(90deg,#fff,#448AFF,#fff);"></div>
                    </v-col>
                    <v-col cols="12" class="text-center pb-1">
                      <div class="text-h6 accent--text">
                        {{ punoIme }}
                      </div>
                    </v-col>
                    <v-col cols="12" class="text-center pt-1">
                      <v-btn v-if="!loggedUser.confirmed" small class="text-none" outlined color="#448AFF"
                             @click="dialog_img = true">
                        <v-icon color="#004379" left>mdi-image-edit-outline</v-icon>
                        {{ $t('upload_image') }}
                      </v-btn>
                      <v-btn v-else-if="loggedUser.active_card" small class="text-none" outlined color="#448AFF"
                             :to="'/cards/' + loggedUser.active_card.uuid">
                        <v-icon color="#004379" left>mdi-account-box-outline</v-icon>
                        {{ $t('digital_link') }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="text-center pt-1" v-if="loggedUser.affiliation === 'student'">
                      <v-btn small class="text-none" outlined color="#448AFF" @click="getGSuiteMail"
                             :loading="loading_get_mail" :disabled="loading_get_mail">
                        <v-icon color="#004379" left>mdi-email-plus-outline</v-icon>
                        {{ $t('Gsuite') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12">
                <a style="width: 100%; color: white; text-decoration: none;" @click="dialog = true">
                  <div class="login-btn blue elevation-0">
                    <span class="login-btn-icon"><img class="mx-3 my-3"
                                                      :src="require('@/assets/eduID_white.svg')"/></span>
                    <div class="login-btn-text ml-6">
                      <v-icon color="white" class="pr-2 text-body-2 text-md-body-1">mdi-shield-check</v-icon>
                      <span class="text-body-2 text-md-body-1 white--text">{{ $t('password_reset') }}</span>
                    </div>
                  </div>
                </a>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" class="mt-3 mb-2">

            <v-card height="100%" outlined>
              <v-row class="mx-3 my-3">
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-account-outline</v-icon>{{ $t('korisnik_title') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.uid }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-account-check</v-icon>{{ $t('Birth_date') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.date_of_birth ? moment(loggedUser.date_of_birth).format("D.M.YYYY.") : '---'}}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-account-box-outline</v-icon>eduID:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">
                      {{ loggedUser.branch === 'skole.sum.ba' ? loggedUser.uid + '@skole.sum.ba' : loggedUser.uid + '@sum.ba' }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-email-outline</v-icon>Email:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.email }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-account-lock-outline</v-icon>{{ $t('role') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.role }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-domain</v-icon>{{ $t('organisation') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.home_org }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-account-question-outline</v-icon>{{ $t('institution_affiliation') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.affiliation }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" v-if="loggedUser.sumEduPersonHomeOrg !== 'skole.sum.ba'">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-school</v-icon>{{ $t('vocation') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.academic_status }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" v-if="loggedUser.sumEduPersonHomeOrg !== 'skole.sum.ba'">
                  <span class="accent--text" style="font-size: 14px"><v-icon size="20" left
                                                                             color="accent">mdi-school-outline</v-icon>{{ $t('academic') }}:</span>
                  <div class="mt-1" style="border: 1px solid #576078; border-radius: 4px; height: 50px">
                    <p class="mt-3 ml-3" style="font-size: 14px">{{ loggedUser.professional_status }}</p>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-dialog
        v-model="dialog"
        width="500"
        style="z-index: 999 !important;"
    >

      <v-card>
        <v-card-title
            primary-title>
          <v-icon left>mdi-key</v-icon>
          {{ $t('password_reset') }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          <v-text-field v-model="password" outlined :label="$t('enter_new_pw')" @click:append="show1 = !show1"
                        hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false, password = ''" class="text-none" depressed large outlined>{{ $t('close') }}</v-btn>
          <v-btn @click="resetPassword()" color="accent" class="text-none" :loading="loading"
                 :class="loading ? 'disable-events' : ''" depressed large>{{ $t('save_changes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialog_img"
        width="500"
        style="z-index: 998 !important;"
    >
      <v-card>
        <v-card-title
            primary-title>
          <v-icon left>mdi-image-edit-outline</v-icon>
          {{ $t('upload_image') }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          <vue-dropzone
              ref="myVueDropzone"
              :id="'dropZone_image'"
              :name="'Slika'"
              :options="dzSingle"
              v-model="slika"
              style="margin-top: 5px"
              @vdropzone-success="successEvent"
              @vdropzone-sending="startBuffer"
              @vdropzone-removed-file="removeThisFile"
              @vdropzone-complete="(file) => onFileUpload(file, item)"
          >
          </vue-dropzone>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_img = false; $refs.myVueDropzone.removeAllFiles(); upload_btn = false" class="text-none" depressed large
                 outlined>{{ $t('close') }}
          </v-btn>
<!--          <v-btn @click="addImage" color="accent" class="text-none" :loading="loading"-->
<!--                 :class="loading ? 'disable-events' : ''" depressed large :disabled="!upload_btn">Spremi sliku-->
<!--          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        style="z-index: 999 !important; position: fixed;"
        v-model="snackbar"
        :timeout="4000"
        :value="true"
        absolute
        top
        :color="snackbar_color"
        right
    >
      {{ snackbar_text }}
    </v-snackbar>
    <v-dialog v-model="dialog_reset" width="600">
      <v-card>
        <v-card-title
            primary-title>
          <v-icon left>mdi-email-lock</v-icon>
          {{ $t('Gsuite') }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;" v-if="reset">
          <div>{{ $t('dialog_gsuite_text1') }}</div>
        </v-card-text>
        <v-card-text style="padding-top: 20px;" v-else>
          <div>
            <span class="font-weight-bold">{{ $t('your_email') }}: </span>
            <span>{{email_data.email}}</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ $t('password') }}: </span>
            <span>{{email_data.password}}</span>
          </div>
          <div class="pt-4">
            <span class="font-weight-bold">{{ $t('dialog_gsuite_text2') }} <a href="https://www.google.com/intl/hr/gmail/about/#" target="_blank">{{ $t('link') }}</a>!</span>
          </div>
          <div>
            <span class="font-weight-bold red--text">{{ $t('copy_pw') }}</span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="GSuiteMailReset" color="accent" class="text-none" depressed large outlined :loading="loading_reset" :class="loading_reset ? 'disable-events' : ''">
            {{ $t('reset_pw') }}
          </v-btn>
          <v-btn @click="dialog_reset = false; email_data = [];" color="accent" class="text-none" :loading="loading"
                 :class="loading ? 'disable-events' : ''" depressed large>{{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialog_magla"
        height="400"
        width="500"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-title>{{ $t('photo_validation') }}</v-card-title>
        <v-card-text>
          <br>
          {{ bufferText }}
          <v-progress-linear
              v-model="value"
              :buffer-value="bufferValue"
              color="white"
              style="margin-top:30px; margin-bottom: 30px;"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Footer/>
  </div>
</template>

<script>
import Api2 from "@/services/Api2";
import Footer from "@/layout/sections/Footer";
import {serverBus} from '@/main'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: "HomeView.vue",
  created() {
    if(this.$route.params.lang === 'en')
      this.breadcrumbs = this.breadcrumbs_en
    else
      this.breadcrumbs = this.breadcrumbs_hr
    if (this.$route.query.action === 'gsuite')
      this.getGSuiteMail()

    // console.log(window.innerWidth)

    if (window.innerWidth < 960) {
      this.small = true
    }
    this.getUser();
    serverBus.$on('logged-in-out', (loggedIn) => {
      self.loggedIn = loggedIn;

      if (!self.loggedIn) {
        // this.$store.commit('setUser', {});
        // this.$store.commit('setPermissions', []);

        // this.clearLocalStorage();
        let apiUrl = process.env.VUE_APP_API_URL;
        let host = `${window.location.protocol}//${location.host}`
        window.location.href = `${apiUrl}sso/logout?redirect_to=${host}`

      }
    });
  },
  components: {
    Footer,
    vueDropzone: vue2Dropzone
  },
  methods: {
    getUser() {
      this.$axios
          .get("sso/user")
          .then(response => {
            this.loggedUserObj = response.data.data
            this.loggedUser = response.data.data
            this.punoIme = this.loggedUser.first_name + ' ' + this.loggedUser.last_name
            this.breadcrumbs.push({
              'text': this.loggedUser.first_name + ' ' + this.loggedUser.last_name,
              'disabled': true,
              'href': 'admin'
            })
          })
          .catch(error => {
            console.log(error);
          });
    },
    resetPassword() {
      this.loading = true;
      let reqBody = {
        password: this.password
      }
      this.$axios.post('eduid/user/changePassword', reqBody)
          .then((response) => {
            if(response.status == 200) {
              this.snackbar = true
              this.snackbar_text = "Lozinka promjenjena!"
              this.snackbar_color = 'success'
            }
          })
          .catch(function () {
            this.snackbar = true
            this.snackbar_text = "Nešto je pošlo krivo!"
            this.snackbar_color = 'error'
          })
          .finally(() => {
            this.password = ''
            this.dialog = false
            this.loading = false
          });
    },
    performLogout: function () {
      serverBus.$emit('logged-in-out', false)
    },

    getGSuiteMail() {
      this.$router.replace({query: Object.assign({...this.$route.query}, {action: 'gsuite'})}, () => {});
      let self = this;
      this.loading_get_mail = true
      Api2.post('gsuite/create')
          .then((res) => {
            this.email_data = res.data
            if(res.status == 200) {
              this.reset = false
              this.dialog_reset = true
            }
          })
          .catch(function (error) {
            if (error.response.status == 409) {
              self.reset = true
              self.dialog_reset = true
            } else {
              self.snackbar = true
              self.snackbar_text = 'Nešto je pošlo krivo!'
              self.snackbar_color = 'error'
            }
          })
          .finally(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.action;
            this.$router.replace({ query });
            this.loading_get_mail = false
          });
    },

    GSuiteMailReset() {
      let self = this;
      this.email_data = []
      this.loading_reset = true
      Api2.post('gsuite/reset')
          .then((res) => {
            // console.log(res)
            this.email_data = res.data
            if(res.status == 200) {
              this.reset = false
              this.dialog_reset = true
            }
          })
          .catch(function (error) {
            if (error.response.status == 409) {
              self.dialog_reset = true
            } else {
              self.snackbar = true
              self.snackbar_text = 'Nešto je pošlo krivo!'
              self.snackbar_color = 'error'
            }
          })
      .finally(() => {
        this.loading_reset = false
      });
    },

    addImage() {
      this.loading = true;

      this.$axios.post('user/changeAvatar', {'avatar_id': this.avatar_id})
          .catch(function () {
            this.snackbar = true
            this.snackbar_text = "Nešto je pošlo krivo!"
            this.snackbar_color = 'error'
          })
          .finally(() => {
            this.$refs.myVueDropzone.removeAllFiles()
            this.snackbar = true
            this.snackbar_text = "Slika promjenjena!"
            this.snackbar_color = 'success'
            this.password = ''
            this.dialog_img = false
            this.loading = false;
            this.getUser()
          });
    },

    removeThisFile() {
      // console.log('izbrisano')
      this.snackbar_text = 'Fotografija izbrisana!'
      this.snackbar = true
      this.snackbar_color = 'success'
      this.upload_btn = false;
      // this.$refs.myVueDropzone.removeFile()
      // console.log("File removed!")
    },

    successEvent(file, response) {
      this.dialog_magla = false;
      // console.log(file)
      // console.log(response)
      // alert(response)

      this.upload_btn = true
      this.snackbar_text = 'Uspješno, fotografija zadovoljava sve uvjete!'
      this.snackbar = true
      this.snackbar_color = 'success'

      this.$refs.myVueDropzone.removeAllFiles()
      this.dialog_img = false
      this.loading = false

      this.getUser()

    },

    startBuffer(){
      this.dialog_magla = true;
      this.bufferText = 'Provjera fotografije..'

      clearInterval(this.interval)

      const self = this;
      this.value = 10
      this.bufferValue = 20

      setTimeout(() => {
        self.value = 20
        this.bufferValue = 40
      }, 1000)

      setTimeout(() => {
        self.value = 40
        this.bufferValue = 100
        this.bufferText = 'Provjera lica..'
      }, 2000)

      setTimeout(() => {
        self.value = 80
        this.bufferText = 'Provjera pozadine..'
      }, 3300)

      setTimeout(() => {
        self.value = 100
        this.bufferText = 'Još samo trenutak..'
      }, 4500)

      setTimeout(() => {
        self.value = 101
      }, 5400)
    },

    uploadTheFile(file) {
      this.form_1.append('image', file)
      this.$axios.post('http://photoid-api.sumit.sum.ba:8080/api/image/check', this.form_1, {
        headers: {
          "Authorization": 'Bearer EBA341EA81F3BFABC592FA19FBA84',
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*"
        }
      })
    },

    onFileUpload(file) {
      this.dialog_magla = false;
      if (file.accepted) {
        const response = file.xhr.response
        let upl_file = JSON.parse(response)
        this.avatar_id = upl_file.id
        // console.log(this.avatar_id)
        // this.snackbar_text = 'Uspješno!'
        // this.snackbar = true
        // this.snackbar_color = 'success'
        // console.log(upl_file)
        if(upl_file.score < 0.7) {
          this.upload_btn = false
          this.snackbar_text = upl_file.background + ', ' + upl_file.quality
          this.snackbar = true
          this.snackbar_color = 'error'
        }
      } else {
        this.snackbar_text = 'Nešto je pošlo krivo!'
        this.snackbar = false
        this.snackbar_color = 'error'
      }
    },
  },
  data: function () {
    return {
      dialog_img: false,
      dialog_reset: false,
      loading_get_mail: false,
      loading_reset: false,
      reset: false,
      email_data: [],
      form: {},
      form_1: new FormData(),
      avatar_id: null,
      loggedUser: [],
      punoIme: '---',
      loggedUserObj: [],
      small: false,
      snackbar_text: '',
      snackbar: false,
      snackbar_color: '',
      menu: false,
      show1: false,
      dialog: false,
      loading: false,
      dialog_magla: false,
      value: 10,
      bufferValue: 20,
      bufferText: '',
      password: '',
      slika: null,
      upload_btn: false,
      breadcrumbs: [],
      breadcrumbs_en: [
        {
          text: 'Homepage',
          disabled: false,
          href: '/',
        },
        {
          text: 'User',
          disabled: false,
          href: 'admin',
        },
      ],
      breadcrumbs_hr: [
        {
          text: 'Naslovnica',
          disabled: false,
          href: '/',
        },
        {
          text: 'Korisnik',
          disabled: false,
          href: 'admin',
        },
      ],
      dzSingle: {
        // url: 'https://api.eduid.sum.ba/files?folder=avatars',
        url: 'https://api.eduid.sum.ba/user/avatar',
        // autoProcessQueue: true,
        // paramName: "image",
        // url: 'http://photoid-api.sumit.sum.ba:8080/api/image/check',
        // headers: {"Authorization": 'Bearer EBA341EA81F3BFABC592FA19FBA84', "Accept": "*/*", "Access-Control-Allow-Origin": "*"},
        withCredentials: true,
        method: 'POST',
        maxFilesize: 5,
        maxFiles: 1,
        manuallyAddFile: true,
        addRemoveLinks: true,
        duplicateCheck: true,
        resizeWidth: 128,
        resizeHeight: 128,
        dictDefaultMessage: 'Priložite sliku..',
        dictRemoveFile: "Izbriši sliku",
        transformFile: function (file, done) {
          var self = this;
          var myVueDropzone = this;
          // Create the image editor overlay
          var editor = document.createElement('div');
          editor.style.position = 'fixed';
          editor.style.left = 0;
          editor.style.right = 0;
          editor.style.top = 0;
          editor.style.bottom = 0;
          editor.style.zIndex = 9999;
          editor.style.backgroundColor = '#000';
          document.body.appendChild(editor);

          // Create confirm button at the top left of the viewport
          var buttonConfirm = document.createElement('button');
          buttonConfirm.style.position = 'absolute';
          buttonConfirm.style.left = '10px';
          buttonConfirm.style.top = '10px';
          buttonConfirm.style.zIndex = 9999;
          buttonConfirm.style.color = 'black';
          buttonConfirm.style.fontSize = '12px';
          buttonConfirm.style.fontWeight = 'bold';
          buttonConfirm.style.padding = '7px';
          buttonConfirm.style.borderRadius = '5px';
          buttonConfirm.style.backgroundColor = 'white';
          buttonConfirm.textContent = 'Obreži i zatvori';
          editor.appendChild(buttonConfirm);
          buttonConfirm.addEventListener('click', function () {
            // Get the canvas with image data from Cropper.js
            var canvas = cropper.getCroppedCanvas({
              width: 480,
              height: 1000
            });
            // Turn the canvas into a Blob (file object without a name)
            canvas.toBlob(function (blob) {
              myVueDropzone.createThumbnail(
                  blob,
                  myVueDropzone.options.thumbnailWidth,
                  myVueDropzone.options.thumbnailHeight,
                  myVueDropzone.options.thumbnailMethod,
                  false,
                  function (dataURL) {

                    // Update the Dropzone file thumbnail
                    myVueDropzone.emit('thumbnail', file, dataURL);
                    // Return the file to Dropzone
                    done(blob);
                  });
            });
            // Remove the editor from the view
            document.body.removeChild(editor);
          });

          // Create an image node for Cropper.js
          var image = new Image();
          image.src = URL.createObjectURL(file);
          editor.appendChild(image);

          // Create Cropper.js
          var cropper = new Cropper(image, {aspectRatio: 4 / 5});
        }
      },
    };
  }
};
</script>

<style>
.login-btn {
  position: relative;
  display: flex;
  width: 100%;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.login-btn-icon {
  position: absolute;
  left: 0;
  height: 100%;
  width: 80px;
  background-color: #004379;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

@media only screen and (max-width: 380px) {
  .login-btn-text {
    margin-left: 80px !important;
  }
}
</style>
